import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import useCopyToClipboard from '../../hooks/useCopyToClipboard';
const CopyLink = props => {
  const {
    url,
    linkText,
    copiedText,
    resetTimeout,
    className
  } = props;
  const {
    t
  } = useTranslation();
  const classNames = c('CopyLink', className);
  const {
    copied,
    copyToClipboard
  } = useCopyToClipboard(url, resetTimeout);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: url,
    className: "CopyLink__url a no-styling",
    onClick: copyToClipboard
  }, copied ? copiedText || t('copy_link.copied') : url), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "a no-styling",
    "aria-describedby": url,
    onClick: copyToClipboard
  }, linkText || t('copy_link.link_text')));
};
export default CopyLink;